// Languages.js
import React, { useEffect, useState } from "react";
import IncludeSideBar from "../../Components/Sidebar/IncludeSideBar";
import styles from "./Languages.css"; // Import the CSS module
import useAuth from '../../../src/useAuth'

function Languages() {
  const { user } = useAuth()
  // const role = user ? user.role : null;
  // console.log(user?.permissions?.Videos?.Delete?.selected, "video section user?.permissions?.Users")
  const hasAddLanguage = user?.permissions?.Languages?.['Add Language']?.selected || user?.role === 'superadmin';
  const hasDeleteLanguage=user?.permissions?.Languages?.['Delete Language']?.selected || user?.role === 'superadmin'
  const languagesApis = require("../../apis/languages");
  const [languagesData, setLanguagesData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [newLanguage, setNewLanguage] = useState({ name: "", code: "" });
  const [showAddModal, setShowAddModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  

  // Function to fetch existing languages
  const getAllLanguages = async () => {
    try {
      const result = await languagesApis.getAllLanguages(currentPage, itemsPerPage);
      // console.log(result.config.url, "URL");
      console.log(result.data, "GET DATA");
      setLanguagesData(result.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getAllLanguages(currentPage, itemsPerPage);
  }, [currentPage, itemsPerPage]);

  

  // Function to handle adding a new language
  const handleAddLanguage = async () => {
    setIsLoading(true)
    try {
      // Send a request to your API to add the new language
      await languagesApis.addAllLanguages(newLanguage);
      setShowAddModal(false);
     

      getAllLanguages();
      

      setNewLanguage({ name: "", code: "" }); 
      // Refresh the language list
    } catch (error) {
      console.error(error);
    }finally {
      setIsLoading(false);
    }
  };
    // Function to handle deleting a new language

    const handleDelete = async (id) => {
      try {
        await languagesApis.deleteAllLanguages(id);
        getAllLanguages();
      } catch (error) {
        console.error("Error deleting country:", error);
      }
    };
    const handlePageChange = (newPage) => {
      console.log(newPage,"newPage")
      
      setCurrentPage(newPage);
    };

   
    const handleNoAccess = () => {
      alert('You are not able to access this feature.');
    };

  return (
    <IncludeSideBar>
    <div className={styles['languages-container']}>
      <p>Here we are displaying the details of Languages:</p>

      <button onClick={() => {
        if(hasAddLanguage){
          setShowAddModal(true)
        }else{
          handleNoAccess()
        }
      }} 
      style={{
        backgroundColor:
          !hasAddLanguage
            ? '#C5C6C7'
            : '', // Set red background when there is access
        cursor: !hasAddLanguage ? 'not-allowed' : 'pointer', // Changes cursor when disabled
      }}
      className={styles['languages-add-button']}>
        Add Language
      </button>

      {showAddModal && (
        <div className={styles['languages-modal']}>
          <div className={styles['languages-modal-content']}>
            <h2>Add Language</h2>
            <label>
              Name:
              <input
                type="text"
                value={newLanguage.name}
                onChange={(e) => setNewLanguage({ ...newLanguage, name: e.target.value })}
              />
            </label>
            <label>
              Code:
              <input
                type="text"
                value={newLanguage.code}
                onChange={(e) => setNewLanguage({ ...newLanguage, code: e.target.value })}
              />
            </label>
            <button onClick={handleAddLanguage}>Add</button>
            <button onClick={() => setShowAddModal(false)}>Cancel</button>
          </div>
        </div>
     ) }

      {isLoading ? (
        <p className={styles['loading']}>Loading...</p>
      ) : (
        <table className={styles['language-table']}>
          <thead>
            <tr>
              <th>#</th>
              <th>Name</th>
              <th>Code</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {languagesData.map((language, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{language.name}</td>
                <td>{language.code}</td>
                <td><button onClick={() => {
                  if(hasDeleteLanguage){
                    handleDelete(language.id)
                  }else{
                    handleNoAccess()
                  }
                }}
                style={{
                  backgroundColor:
                    !hasDeleteLanguage
                      ? '#C5C6C7'
                      : '', // Set red background when there is access
                  cursor: !hasDeleteLanguage ? 'not-allowed' : 'pointer', // Changes cursor when disabled
                }}
                >Delete</button></td>
              </tr>
            ))}
          </tbody>
        </table>
        
        
      )}
     <div className={styles['pagination']}>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>Page {currentPage}</span>
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          // disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

    </div>
    </IncludeSideBar>
  );
}

export default Languages;
